import { Route, Routes } from "react-router-dom";
import { LackOfReconciliation } from "./list";

export default function LackOfReconciliationRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LackOfReconciliation />} />
    </Routes>
  );
}
